import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'

import MaterialsDt from '@/services/dataTransferModules/materialsDt'

import { getMaterialTitle } from '@/helpers/entities/materials/materialsHelpers'

export default function useMaterials(params = {}) {
	const { t: $t } = useI18n()

	const materialsDt = new MaterialsDt()

	const {
		selectedCompanyId,
		showUiErrorNotification,

		loadEntityFlags: flags,

		entities: fullMaterials,
		getEntities: getFulledMaterials,

		extendedEntities: extendedMaterials,
		getExtendedEntities: getExtendedMaterials,

		hashedExtendedEntities: hashedExtendedMaterials,
		getHashedExtendedEntities: getHashedExtendedMaterials,

		basedEntities: baseMaterials,
		getBasedEntities: getBasedMaterials,

		hashedBasedEntities: hashedBasedMaterials,
		getHashedBasedEntities: getHashedBasedMaterials,

		createEntity: createMaterials,

		entity: material,
		getEntity: getMaterial,

		entityPopup: materialsPopup,
		getEntityPopup: getMaterialsPopup,

		entityPreview: materialsPreview,
		getEntityPreview: getMaterialsPreview,

		patchEntity: updateMaterials,

		updateEntity: fullUpdateMaterials,

		deleteEntity: deleteMaterials,
	} = useBlProviders(materialsDt, Object.assign({
		postProcessEntityCallback: (material) => {
			material.__ao__title = getMaterialTitle(material)
			return material
		},

		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Materials loaded with an error!'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Couldn`t add a new resource. Please contact technical support team.'),

		showErrorNotificationForLoadingOneEntity: true,

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Error saving resource.'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Couldn`t remove. Please contact technical support team.'),
	}, params))

	const materialsCurrentPrices = ref({})

	const getMaterialsCurrentPrices = () => {
		return new Promise((resolve, reject) => {
			flags.isLoading = true

			materialsDt.getCurrentPricesOfMaterials(selectedCompanyId.value)
				.then((res) => {
					const pricesHash = {}
					if (Array.isArray(res)) {
						res.forEach((el) => {
							if (el && el.id !== undefined) {
								pricesHash[el.id] = el
							}
						})
					}

					materialsCurrentPrices.value = pricesHash
					flags.isLoading = false

					resolve(materialsCurrentPrices.value)
				})
				.catch(() => {
					flags.isLoading = false
					showUiErrorNotification({
						timeout: 3000,
						text: $t('Error loading current material prices'),
					})

					reject()
				})
		})
	}

	return {
		flags,
		fullMaterials,
		baseMaterials,
		extendedMaterials,
		materialsPreview,
		materialsPopup,
		material,
		materialsCurrentPrices,

		getBasedMaterials,
		getMaterialsCurrentPrices,
		getExtendedMaterials,
		getFulledMaterials,
		getMaterialsPreview,
		getMaterialsPopup,
		getMaterial,
		createMaterials,
		deleteMaterials,
		updateMaterials,
		fullUpdateMaterials,

		hashedExtendedMaterials,
		getHashedExtendedMaterials,

		hashedBasedMaterials,
		getHashedBasedMaterials,
	}
}
